module.exports = __webpack_public_path__ + "img/facebook-f-brands.ac3d8ad8.svg";